import { Idl } from '@coral-xyz/anchor'

interface IdlAccountRef {
  address?: string
}

/**
 * The IDL with its program address replaced: `address` itself and every
 * instruction account pinned to the program (`self_program`). A redeployed
 * program keeps its IDL but gets a new id, which the API reports per round
 * (`contractAddress`); deriving PDAs and building instructions from that id
 * keeps bets working without a frontend release.
 */
export const withProgramAddress = <T extends Idl>(
  idl: T,
  address: string
): T => {
  if (idl.address === address) return idl

  const instructions = idl.instructions.map(instruction => ({
    ...instruction,
    accounts: instruction.accounts.map(account =>
      (account as IdlAccountRef).address === idl.address ?
        { ...account, address }
      : account
    )
  }))

  return { ...idl, address, instructions }
}
